import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AppConfigComponent } from './app.config.component';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MessageService } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SidebarModule,
        RadioButtonModule,
        ButtonModule,
        InputSwitchModule,
        MenuModule,
        ToastModule,
        ChipModule,
        SplitButtonModule  
    ],
    declarations: [
        AppConfigComponent
    ],
    exports: [
        AppConfigComponent
    ],
    providers: [MessageService],
})
export class AppConfigModule { }
